import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { get_cart_Data } from "../../redux/action";
import { useWishlist } from "../../context/wishlistContext";
import { FaSignOutAlt, FaShoppingCart, FaSignInAlt, FaUserPlus, FaUser, FaHeart } from 'react-icons/fa';
import { FiSearch } from 'react-icons/fi';
import { get } from "../../_services/apiService";
import { API_URL } from "../../_services/apiUrl";

const offerTop = [
    {
        title: ' Shop Gailee! Shop for ₹4999 & Get Free White Pants. Free Shipping on Orders Above ₹3999.',
    }
]

const Header = () => {
    const dispatch = useDispatch();
    const { wishlist, fetchWishlist } = useWishlist();
    const navigate = useNavigate();
    const cartData = useSelector((state) => state.cartReducer.cart);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const loginId = localStorage.getItem("loginId");
    const [isOpen, setIsOpen] = useState(false);
    const [searchText, setSearchText] = useState('');
    const searchBoxRef = useRef(null);
    const searchButtonRef = useRef(null);
    const [productCategoryData, setProductCategoryData] = useState([]);
    const [subCategoryData, setSubCategoryData] = useState([]);
    const [productDetail, setProductDetail] = useState([]);
    const [filteredSubCategories, setFilteredSubCategories] = useState([]);

    const GetProductCategoryDetail = async () => {
        try {
            const response = await get(API_URL?.GetProductCategory);
            if (response.isSuccess === 200) {
                const filteredData = response?.data?.filter(product => product.isDisplay);
                setProductCategoryData(filteredData);
            } else {
                setProductCategoryData([]);
            }
        } catch (error) {
            setProductCategoryData([]);
        }
    };

    const GetProductSubCategoryByCategoryId = async () => {
        try {
            const response = await get(`${API_URL?.GetProductSubCategory}`);
            if (response.isSuccess === 200) {
                const filteredData = response?.data?.filter(product => product.isDisplay);
                setSubCategoryData(filteredData);
            }
        } catch (error) {
            setSubCategoryData([]);
        }
    };

    const GetProductDetail = async () => {
        try {
            const response = await get(`${API_URL?.GetProductDetail}`);
            if (response.isSuccess === 200) {
                const filteredData = response?.data?.filter(product => product.isDisplay);
                setProductDetail(filteredData);
            }
        } catch (error) {
            setProductDetail([]);
        }
    };

    useEffect(() => {
        GetProductCategoryDetail();
        GetProductDetail();
        GetProductSubCategoryByCategoryId();
    }, []);

    const onMouseEnter = (categoryId) => {
        const filtered = subCategoryData?.filter(
            (sub) => sub?.productCategoryId === categoryId
        );
        setFilteredSubCategories(filtered || []);
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        if (searchText.trim()) {
            navigate(`/search?query=${encodeURIComponent(searchText)}`);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                isOpen &&
                searchBoxRef.current &&
                !searchBoxRef.current.contains(event.target) &&
                searchButtonRef.current &&
                !searchButtonRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside, true);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside, true);
        };
    }, [isOpen]);

    const getTotalQuantity = useCallback(() => {
        return cartData.reduce((acc, item) => acc + (item.quantity || 0), 0);
    }, [cartData]);

    const [totalQuantity, setTotalQuantity] = useState(getTotalQuantity());

    useEffect(() => {
        setTotalQuantity(getTotalQuantity());
    }, [getTotalQuantity]);

    useEffect(() => {
        if (loginId) {
            setIsLoggedIn(true);
        } else {
            setIsLoggedIn(false);
        }
    }, [loginId]);

    useEffect(() => {
        dispatch(get_cart_Data());
        fetchWishlist();
    }, [dispatch, fetchWishlist, wishlist]);

    // Logout function
    const onLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        setIsLoggedIn(false);
        navigate('/');
        dispatch(get_cart_Data());
        fetchWishlist();
    };

    const onCart = () => {
        const existingItemDetails = JSON.parse(localStorage.getItem('itemDetail')) || [];
        const existingCartItemDetails = JSON.parse(localStorage.getItem('cartItemDetail')) || [];

        if (existingItemDetails.length > 0 || existingCartItemDetails.length > 0) {
            localStorage.removeItem('cartItemDetail');
            localStorage.removeItem('itemDetail');
        }

        navigate('/cart');
        sessionStorage.setItem('priviousUrl', '/cart');
    }

    const onWishList = () => {
        if (loginId) {
            navigate('/wishlist');
        } else {
            sessionStorage.setItem("priviousUrl", "/wishlist");
            navigate('/login');
        }
    }

    const onLogin = () => {
        navigate('/login');
    }

    const onRegister = () => {
        navigate('/register');
    }

    const onProducts = (item) => {
        localStorage.setItem('productSubCategoryId', item?.productSubCategoryId);
        navigate(`/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}`);
        sessionStorage.setItem('priviousUrl', `/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}`);
    };

    const onProductsPage = () => {
        navigate('/products');
    }

    const onAbout = () => {
        navigate('/about-us');
        sessionStorage.setItem('priviousUrl', `/about-us`);
    }

    const onBlog = () => {
        navigate('/blog');
        sessionStorage.setItem('priviousUrl', `/blog`);
    }

    const onContactUs = () => {
        navigate('/contact-us');
        sessionStorage.setItem('priviousUrl', `/contact-us`);
    }

    const onSearch = () => {
        setSearchText('');
        setIsOpen(prev => !prev);
    };

    const onProductSubCategory = (item) => {
        localStorage.setItem('productCategoryId', item?.productCategoryId);
        sessionStorage.setItem('priviousUrl', `/${item?.categoryName.replace(/\s+/g, '_')}`);
        navigate(`/${item?.categoryName.replace(/\s+/g, '_')}`);
    };

    return (
        <div className="main_header_wrapper">
            <div className="top_header">
                <div className="top_header_inner marquee d-flex justify-content-lg-end justify-content-between align-items-center py-3">
                    <div className="scroll w-100">
                        <div>
                            {offerTop?.map((item, i) => (
                                <p key={i} className="category mb-0">{item?.title}</p>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <header className="header" id="header">
                <nav className="navbar navbar-light navbar-expand-lg p-0 relative">
                    <div className="container">
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <div className="d-flex align-items-center gap-3 ">
                                <button className="navbar-toggler menu_icon px-0" type="button" data-bs-toggle="offcanvas"
                                    data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
                                    <span className="navbar-toggler-icon mobile_header_menu"></span>
                                </button>
                                <Link className="navbar-brand p-0" to="/">
                                    <div className="logo header_logo">
                                        <img src="../../../images/logo-white.png" className="without_hover" alt="" />
                                    </div>
                                </Link>
                            </div>
                            <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasNavbar"
                                aria-labelledby="offcanvasNavbarLabel">
                                <div className="offcanvas-header">
                                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas"
                                        aria-label="Close"></button>
                                </div>
                                <div className="offcanvas-body">
                                    <ul className="navbar-nav justify-content-center align-items-center flex-grow-1 menu">
                                        <li className="nav-item">
                                            <Link className="nav-link active" to="/">Home</Link>
                                        </li>
                                        <li className="nav-item">
                                            <span onClick={onAbout} className="nav-link" >About Us</span>
                                        </li>
                                        <li className="nav-item dropdowncustm">
                                            <span
                                                className="nav-link dropdownarrow" >Collections
                                                <i className="fa-solid fa-angle-down"></i>
                                            </span>
                                            <ul className="dropdown-menu-custm">
                                                <li onClick={onProductsPage} className="submenu">
                                                    <span className="dropdownarrow cursor-pointer">
                                                        <span>All</span>
                                                    </span>
                                                </li>

                                                {productCategoryData?.length > 0 && (
                                                    <>
                                                        {productCategoryData.map((item, i) => {
                                                            const matchedSubCategories = subCategoryData.filter(
                                                                (sub) => sub.productCategoryId === item.productCategoryId && sub.isDisplay
                                                            );

                                                            if (matchedSubCategories.length === 0) {
                                                                return null;
                                                            }

                                                            // const hasMultiple = matchedSubCategories.length > 1;
                                                            const hasSingle = matchedSubCategories.length === 1;

                                                            return (
                                                                <li className="submenu" key={i}>
                                                                    {hasSingle ? (
                                                                        <span
                                                                            className="cursor-pointer"
                                                                            onClick={() => onProducts(matchedSubCategories[0])}
                                                                        >
                                                                            {item.displayName}
                                                                        </span>
                                                                    ) : (
                                                                        <>
                                                                            <span
                                                                                onMouseEnter={() => onMouseEnter(item.productCategoryId)}
                                                                                className="dropdownarrow cursor-pointer"
                                                                            >
                                                                                <span onClick={() => onProductSubCategory(item)}>
                                                                                    {item.displayName}
                                                                                </span>
                                                                                <i className="fa-solid fa-angle-right"></i>
                                                                            </span>
                                                                            <ul className="submenu-menu">
                                                                                {filteredSubCategories?.length > 0 ? (
                                                                                    filteredSubCategories?.map((element, j) => {
                                                                                        const matchedProduct = productDetail.filter((sub) =>
                                                                                            (sub.productSubCategoryId === element.productSubCategoryId && sub.isDisplay) ||
                                                                                            (sub.rsubCategoryId && sub.rsubCategoryId.split(',').includes(String(element.productSubCategoryId)))
                                                                                        );

                                                                                        if (matchedProduct.length === 0) {
                                                                                            return null;
                                                                                        }

                                                                                        return (
                                                                                            <li
                                                                                                className="cursor-pointer"
                                                                                                key={j}
                                                                                                onClick={() => onProducts(element)}
                                                                                            >
                                                                                                <span>{element?.displayName}</span>
                                                                                            </li>
                                                                                        )
                                                                                    })
                                                                                ) : (
                                                                                    <p className="not_avaiable">Item not available</p>
                                                                                )}
                                                                            </ul>
                                                                        </>
                                                                    )}
                                                                </li>
                                                            );
                                                        })}
                                                    </>
                                                )}
                                            </ul>
                                        </li>
                                        <li className="nav-item">
                                            <span onClick={onContactUs} className="nav-link" >Contact Us</span>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link active" to="/sizechart">Size Chart</Link>
                                        </li>                                    <li className="nav-item">
                                            <span onClick={onBlog} className="nav-link" >Blog</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="cart_wepper mobile_cart_wepper header_cart_wrapper">
                                <ul className="mb-0" style={{ paddingLeft: "0px" }}>
                                    <li onClick={onSearch} ref={searchButtonRef} className="mobile_cart_wepper_search">
                                        <span title="Search" className="header_icon curser-pointer position-relative">
                                            <FiSearch
                                                style={{
                                                    stroke: '#8e183c',
                                                    strokeWidth: '1px',
                                                    fontSize: '35px',
                                                    width: '30px',
                                                    height: '30px',
                                                }}
                                            />
                                        </span>
                                    </li>
                                    <li>
                                        <span title="Wishlist" onClick={onWishList} className="header_icon curser-pointer position-relative">
                                            <span className="position-absolute translate-middle header_item_wishlist_count" aria-label={`Cart contains ${wishlist?.length} items`} >
                                                {isLoggedIn ?
                                                    wishlist?.length || 0
                                                    : 0
                                                }
                                            </span>
                                            <FaHeart
                                                style={{
                                                    stroke: '#8e183c',
                                                    fill: 'transparent',
                                                    strokeWidth: '24px',
                                                    fontSize: '28px',
                                                    height: '25px',
                                                    width: '32px',
                                                }}
                                            />
                                        </span>
                                    </li>
                                    <li>
                                        <span title="Cart" onClick={onCart} className="header_icon curser-pointer position-relative">
                                            <span className="position-absolute translate-middle header_item_count" aria-label={`Cart contains ${totalQuantity} items`} >
                                                {totalQuantity || 0}
                                            </span>
                                            <FaShoppingCart
                                                style={{
                                                    stroke: '#8e183c',
                                                    fill: 'transparent',
                                                    strokeWidth: '24px',
                                                    fontSize: '28px',
                                                    height: '25px',
                                                    width: '26px',
                                                }}
                                            />
                                        </span>
                                    </li>
                                    <li className="position-relative my_account_wrapper">
                                        <span>
                                            <FaUser
                                                style={{
                                                    stroke: '#8e183c',
                                                    fill: 'transparent',
                                                    strokeWidth: '24px',
                                                    fontSize: '28px',
                                                    height: '26px',
                                                    width: '24px',
                                                }}
                                            />
                                        </span>
                                        <div className="hover_show_wrapper">
                                            <div className="my_account_box">
                                                {isLoggedIn ?
                                                    <>
                                                        <div className="curser-pointer login_signup_btn my_account_buttons">
                                                            <Link to='/my-profile' className="">
                                                                <FaUser style={{ marginRight: '8px' }} />
                                                                My Profile
                                                            </Link>
                                                        </div>
                                                        <div className="login_signup_btn my_account_buttons">
                                                            <Link to='/your-orders' className="curser-pointer">
                                                                <FaShoppingCart style={{ marginRight: '8px' }} />
                                                                Your Orders
                                                            </Link>
                                                        </div>
                                                        <div onClick={onLogout} className="curser-pointer login_signup_btn my_account_buttons">
                                                            <span className="">
                                                                <FaSignOutAlt style={{ marginRight: '8px' }} />
                                                                Logout
                                                            </span>
                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                        <div onClick={onLogin} className="curser-pointer login_signup_btn my_account_buttons">
                                                            <span className="">
                                                                <FaSignInAlt style={{ marginRight: '8px' }} />
                                                                Login
                                                            </span>
                                                        </div>
                                                        <div onClick={onRegister} className="curser-pointer login_signup_btn my_account_buttons">
                                                            <span className="">
                                                                <FaUserPlus style={{ marginRight: '8px' }} />
                                                                Sign Up
                                                            </span>
                                                        </div>
                                                    </>
                                                }

                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </nav>
                {isOpen && (
                    <div className="model_wrapper_shadow">
                        <div className="main_box_modal" ref={searchBoxRef}>
                            <div className="form_butn_wepper">
                                <form onSubmit={handleSearchSubmit} className="row">
                                    <div className="search_global_input d-flex align-items-center col-md-6 col-sm-10 col-11 px-0">
                                        <input
                                            type="search"
                                            className="form-control p-0"
                                            placeholder="Search"
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        />
                                        <span
                                            onClick={handleSearchSubmit}
                                        >
                                            <FiSearch />
                                        </span>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}
            </header>
        </div>
    )
}

export default Header;